import { FontSizes, FontWeights } from '@fluentui/react';
export var getStyles = function (props) {
    var isRead = props.isRead;
    return {
        subjectText: {
            whiteSpace: 'normal',
            margin: '0 0 0 0 !important',
            fontSize: FontSizes.size14,
            fontWeight: isRead ? FontWeights.semibold : FontWeights.bold
        },
        senderName: {
            fontSize: FontSizes.size14,
            fontWeight: isRead ? FontWeights.regular : FontWeights.semibold
        },
        timeDelivered: {
            fontSize: FontSizes.size12,
            fontWeight: isRead ? FontWeights.regular : FontWeights.semibold
        },
        timestampRow: {
            flexGrow: 1,
            justifyContent: 'space-between',
            position: 'relative',
            lineHeight: '20px'
        },
        subjectContainer: {
            flex: 1
        },
        timeHook: [
            'timeHook',
            {
                opacity: 1
            }
        ]
    };
};
//# sourceMappingURL=NotificationHeader.styles.js.map